export default "__VITE_ASSET__B5VZVLh6__"